import { memo } from 'react'
import styles from './styles.module.scss'
import NextImage, { ImageProps } from 'next/image'

interface Props extends ImageProps {
  src: string
  alt: string
  className?: string
}
const Image = (props: Props) => {
  return (
    <figure>
      <picture className={styles.container + ' ' + (props.className || '')}>
        <NextImage
          className="object-cover"
          alt={props.alt || ''}
          fill
          loading="lazy"
          sizes="(min-width: 1024px) 1024px, 100vw"
          {...props}
        />
      </picture>
    </figure>
  )
}

export const ImageResponsive = memo(Image)
